export function TextUppercase(props) {
  return (
    <span className="text-uppercase" id={props.id}>
      {props.children}
    </span>
  );
}

export default TextUppercase;
